if (!customElements.get('complementary-products')) {
  class ComplementaryProducts extends HTMLElement {
    constructor() {
      super();

      this.loadComplementaryProducts();
    }

    loadComplementaryProducts() {
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(html => {
          const responseDOMParser = new window.DOMParser();
          const responseDocument = responseDOMParser.parseFromString(html, 'text/html');
          const responseDocumentComplementaryProducts = responseDocument.querySelector('complementary-products');

          if (!responseDocumentComplementaryProducts || !responseDocumentComplementaryProducts.querySelectorAll('[data-complementary-product]').length) { return; }

          this.innerHTML = responseDocumentComplementaryProducts.innerHTML;
          this.classList.remove('d-none');
        })
        .catch(e => {
          console.error(e);
        });
    }
  }

  customElements.define('complementary-products', ComplementaryProducts);
}